module.exports = __webpack_public_path__ + "media/img/square-logo-small-405ddbc23dd1c9fc0636db2b062f2cee.png";